define('common/views/trial_view',['require','exports','module','base/view','./trial_expiration_popup','env','common/models/appstate','services/auth','i18n','ldsh!../templates/trial'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    TrialExpirationPopup = require('./trial_expiration_popup'),
    config = require('env'),
    AppState = require('common/models/appstate'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
    i18n = require('i18n');

  module.exports = View.extend({
    template: require('ldsh!../templates/trial'),
    className: 'ed-expire',
    helpers: function () {
      return {
        paymentsUrl: config.paymentsUrl,
        trialWarning: i18n.t('trial.warning'),
        companyId: authInfo.getCompanyId(),
      };
    },
    initialize: function () {
      if (!AppState.hasBeenDisplayed()) this.showPopup();
    },
    onRender: function () {
      this.$el.i18n();
    },
    showPopup: function () {
      TrialExpirationPopup.show();
    },
  });
});

